import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import Section from 'components/Section';
import SimpleGrid from 'components/SimpleGrid';
import SizeDependedBlock from 'components/SizeDependedBlock';
import SlideSection from 'components/SlideSection';
import ReviewCard from 'components/cards/ReviewCard';

const ConcertsThematics = ({ themes }) => (
	<SizeDependedBlock>
		<SlideSection
			title="Тематические подборки"
			sliderParams={{ spaceBetween: 12 }}
			items={themes}
		>
			{_(themes).map((item) => (
				<ReviewCard
					size="mobileNarrow"
					key={item._id}
					data={item}
					withDescription={false}
				/>
			))}
		</SlideSection>
		<Section title="Тематические подборки">
			<Container>
				<SimpleGrid>
					{_(themes).map((block) => (
						<ReviewCard size="mobileNarrow" key={block._id} data={block} />
					))}
				</SimpleGrid>
			</Container>
		</Section>
	</SizeDependedBlock>
);

ConcertsThematics.propTypes = {
	themes: PropTypes.array.isRequired
};

export default ConcertsThematics;
